import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { ProgramAssets } from 'features/programs';

const PageProgramAssets = () => {
  const { programId } = useRequiredParams<{ programId: string }>();

  return (
    <AppLayout>
      <ProgramAssets programId={programId} />
    </AppLayout>
  );
};

export default PageProgramAssets;
